import { FC } from 'react';
import { IconButton } from '../iconButton';
import filterIcon from 'assets/icons/filter-icon.svg';
import { SmallCircleButton } from '../circleButtons';
import { FULL_SLOT } from 'shared/consts';
import { CircleButtonContainer, IconButtonContainer } from './styles';

interface FilterIconButtonProps {
	onClick: () => void;
	styles?: {
		iconHeight: string;
		width?: string;
		height?: string;
	};
	showActive?: boolean;
}

export const FilterIconButton: FC<FilterIconButtonProps> = ({
	onClick,
	showActive = false,
}) => {
	return (
		<IconButtonContainer>
			{showActive && (
				<CircleButtonContainer>
					<SmallCircleButton color={FULL_SLOT} size="12px" />
				</CircleButtonContainer>
			)}
			<IconButton
				role="filter-button"
				iconSrc={filterIcon}
				styles={{
					background: 'white',
					height: '32px',
					width: '32px',
					iconHeight: '16px',
				}}
				onClick={onClick}
			/>
		</IconButtonContainer>
	);
};
